import { PrimaryButton,TextField,Stack,Text, Label,DefaultEffects,Nav } from '@fluentui/react';
import React,{useState } from 'react';
import logo from './logo.svg';
import Content from './component/content';


function App(props) {
  const navLinkGroups = [
    {
      name: '계산기',
      links: [
        { name: '물타기 계산기', url: `/stock`, key: 'key1', },
        { name: 'BMI 계산기', url: `/BMI`, key: 'key2',  },
        { name: '길이 계산기', url: `/length`, key: 'key3',  },
       // { name: 'LTV 계산기', url: '', key: 'key3', },
     
      ],
    },
   
  ];
  const [contentType,setContentType] = useState(props.contentType);
  return (
      <div className="App">
        <Stack horizontal wrap>
          <Nav  groups={navLinkGroups} />
          <Content contentType={contentType} />
        </Stack>
      </div>

  );
}

export default App;
